// Auth Routes

export default {
  LOGIN_URL: 'login/',
  SIGNIN_URL: 'authenticate/',
  AZURE_SIGNIN_URL: 'authenticate-azure/',
  LOGOUT_URL: 'logout/',
  GENERATE_TOKEN: 'generate-token/',
  RESET_PASSWORD: 'reset-password/',
  FORGOT_USERNAME: 'forgot-username/',
  LOGGED_IN_USER: 'logged-in-user/',
  SET_PASSWORD: 'set-password/',
  SWITCH_COMPANY: 'switch-company/',
  SET_PROPERTIES: 'companies/:company_id/set-properties/',
  SSO_PROVIDER: 'companies/:company_id/sso/provider/',
  AUTH_PROVIDER: 'auth-provider/',
  GET_SSOGROUPS: 'companies/:company_id/sso/ssogroups/',
  GET_SSOROLES: 'companies/:company_id/sso/ssoroles/',
  REGISTER: 'register/',
  GLOBAL_SETTINGS: 'companies/:company_id/global-settings/',
  HELP_JUICE_URL: 'help-juice/',
  LOCALIZATION: 'localization/',
  
}
